import { SatelliteProductAnalysisStepResponse } from '@6grain/masofa-monolith-api-client/common/model/satelliteProductAnalysisStepResponse';
import { formatAssignmentDuration } from '@app/pages/admin/assignment-duration.util';

/** Whole seconds between two ISO timestamps, or null when either side is missing or inverted. */
export function durationSecondsBetween(started?: string | null, completed?: string | null): number | null {
  if (!started || !completed) {
    return null;
  }
  const start = Date.parse(started);
  const end = Date.parse(completed);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) {
    return null;
  }
  return Math.round((end - start) / 1000);
}

export function assignmentDurationLabel(started?: string | null, completed?: string | null): string {
  return formatAssignmentDuration(durationSecondsBetween(started, completed));
}

/** Finished time. When the client only has the legacy `at` stamp, that stamp is the finished cell. */
export function finishedAt(step: SatelliteProductAnalysisStepResponse): string | null {
  if (step.completedAt) {
    return step.completedAt;
  }
  if (step.startedAt) {
    return null;
  }
  return step.at ?? null;
}

export function stepTypeLabelKey(stepType?: string | null): string {
  return stepType ? `Satellite step ${stepType}` : '—';
}

export function artifactRoleLabelKey(role?: string | null): string {
  return role ? `Artifact role ${role}` : '—';
}

/** Highest command-step attempt on an analysis step. A missing field stays blank; zero stays zero. */
export function attemptCountLabel(step: object): string {
  const value = (step as { attemptCount?: unknown }).attemptCount;
  return typeof value === 'number' && Number.isFinite(value) ? String(value) : '—';
}
